import Vue from "vue";
import Router from "vue-router";
import SurveyRouter from './components/routes.js';
//import NotFound from './components/NotFound.vue'
Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
export default new Router({
    mode: "history",
    routes: [
        ...SurveyRouter
        //  {path: '/*', component: Survey},
        // {path: '/:notFound(.*)', component: NotFound}
    ],
});
